//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: { type: Boolean, required: true },
    onLabel: { type: String, default: '' },
    offLabel: { type: String, default: '' }
  },
  computed: {
    classes () {
      return {
        BaseToggle: true,
        'BaseToggle--checked': this.value
      }
    }
  }
}
